<sxw-side-dialog [(visible)]="isDialogVisible" appendTo="body" outletName="popups" theme="sxw-popup-cards" class="no-sidebar-header">
  <ng-template #header> </ng-template>
  <ng-template #content>
    <h3>{{ "deleteAccount" | translate }}</h3>
    <p class="mb-30px" [innerHTML]="'deleteSecondTitle' | translate"></p>
    <sxw-form [formModel]="formModel">
      <app-delete-account-form></app-delete-account-form>
      <sxw-button
        [disabled]="formModel.formGroup().get('confirmText')?.value !== 'Confirm'"
        [isLoading]="isLoading"
        (onClick)="deleteAccount()"
        class="mt-20px d-block submit-btn"
        theme="btn pink"
        label="continue"></sxw-button>
    </sxw-form>
  </ng-template>
</sxw-side-dialog>
